import Intro from "../pages/intro";
import Login from "../pages/login";
import Home from "../pages/home";
import Profile from "../pages/profile";
import Records from "../pages/records";
import RulesAndRegulations from "../pages/rulesAndRegulations";
import TestRegistration from "../pages/testRegistration";
import TestResult from "../pages/testResult";
import UpdateProfile from "../pages/updateProfile";
import TestAnalysis from "../pages/testAnalysis";
import NotFound from "../pages/notFound";
import Terms from "../pages/terms";
import Privacy from "../pages/privacy";
import Biorhythm from "../pages/biorhythm";
import Dashboard from "../pages/dashboard";
import DashboardProfiles from "../pages/dashboardProfiles";
import DdashboardProfile from "../pages/dashboardProfile";
import DashboardProfileRecord from "../pages/dashboardProfileRecord";
import DashboardTests from "../pages/dashboardTests";
import DashboardInvalidComponents from "../pages/dashboardInvalidComponents";
import DashboardMessages from "../pages/dashboardMessages";
import ProfileInfo from "../pages/profileInfo";
import ProfilePassword from "../pages/profilePassword";
import Support from "../pages/support";
import ComingSoon from "../pages/comingSoon";
import ProAdditionalInformation from "../pages/proAdditionalInformation";
import Checkout from "../pages/checkout";
import Transactions from "../pages/transactions";
import TempUsers from "../pages/tempUsers";
import Watch from "../pages/watch";

export const mainRoutes = [
  // { pathName: "/watch", element: <Watch /> },

  { pathName: "/coming-soon", element: <ComingSoon /> },
  { pathName: "/intro", element: <Intro /> },
  { pathName: "/login", element: <Login /> },
  { pathName: "/", element: <Home /> },
  { pathName: "/test-registration", element: <TestRegistration /> },
  {
    pathName: "/additional-information/:id",
    element: <ProAdditionalInformation />,
  },
  { pathName: "/test-analysis/:id", element: <TestAnalysis /> },
  { pathName: "/test-result/:id", element: <TestResult /> },

  { pathName: "/profile", element: <Profile /> },
  { pathName: "/profile/update", element: <ProfileInfo /> },
  { pathName: "/profile/password", element: <ProfilePassword /> },
  { pathName: "/profile/transactions", element: <Transactions /> },
  { pathName: "/update-profile", element: <UpdateProfile /> },
  { pathName: "/records", element: <Records /> },
  { pathName: "/subcategory-users", element: <TempUsers /> },
  { pathName: "/biorhythm", element: <Biorhythm /> },
  { pathName: "/rules-and-regulations", element: <RulesAndRegulations /> },
  { pathName: "/terms", element: <Terms /> },
  { pathName: "/privacy", element: <Privacy /> },
  { pathName: "/support", element: <Support /> },
  { pathName: "/checkout/:paymentId", element: <Checkout /> },

  { pathName: "/dashboard", element: <Dashboard /> },
  { pathName: "/dashboard-profiles", element: <DashboardProfiles /> },
  { pathName: "/dashboard-profiles/:id", element: <DdashboardProfile /> },
  { pathName: "/dashboard-tests", element: <DashboardTests /> },
  { pathName: "/dashboard-messages", element: <DashboardMessages /> },
  {
    pathName: "/dashboard-invalid-components",
    element: <DashboardInvalidComponents />,
  },
  {
    pathName: "/dashboard-records/:test/:id",
    element: <DashboardProfileRecord />,
  },

  { pathName: "*", element: <NotFound /> },

  // Campaign's Redirects
  { pathName: "/yalda", element: <Home /> },
];
